import * as React from 'react';
import { UIComponentState, UIComponentHandler, UIDataModel } from '../../../toolkit/uicomponent';
import { BaseContext } from '../../../../utils/basecontext';
import { FeaturedCategoryComponentProps} from './featuredcomponent';
import { FeaturedCategoryCSSStyle } from './featuredcategorycss';
import { ToneDto } from '../../../../core/dto/tonedto';
import { GridTabViewModelImpl } from '../../../toolkit/gridtabs/gridtabviewmodel';
import { FeaturedToneListViewModelImpl, FeaturedToneRowOptionsImpl, ProfileTunesFeaturedToneRowOptionsImpl } from './viewmodel/featuredcategorylistviewmodel';
import { FeaturedCategoryTabViewModelImpl } from './featuredcategorytabviewmodel';
import { UIComponentViewImpl } from '../../../toolkit/uicomponentview';
import { GridTabComponent } from '../../../toolkit/gridtabs/gridtabcomponent';
import { AudioPlayerWithProgressImpl } from '../../../toolkit/player/playerwithprogress/playerwithprogressimpl';
import { RoutingFeatures } from '../../navigation/routingfeature';
// import { Strings } from 'src/com/sixdee/crbtportal/utils/resources/strings';


export class FeaturedCategoryViewImpl extends UIComponentViewImpl<UIDataModel>
{
    private genericTabViewModel: GridTabViewModelImpl;
    private gridTabRef: GridTabComponent;
    private audioPlayerWithProgress: AudioPlayerWithProgressImpl;
    private featuredCategoryMap: Map<string, string>;
    private featuredCategoryTonesListMap = new Map<string, ToneDto[]>();

    constructor(basecontext: BaseContext, uiComponentHandler: UIComponentHandler)
    {
        super(basecontext, uiComponentHandler);
        // .slice(0, 8)
         this.featuredCategoryTonesListMap = new Map<string, ToneDto[]>();
        this.genericTabViewModel = new GridTabViewModelImpl();
        this.audioPlayerWithProgress = new AudioPlayerWithProgressImpl(basecontext.getPlayerManager().getAudioPlayer());
    }

    setFeaturedCategoryMap(featuredCategoryMap: Map<string, string>)
    {
        this.featuredCategoryMap = featuredCategoryMap;
    }

    bindHandlers()
    {
        this.onTabSelected = this.onTabSelected.bind(this);
        this.showMore = this.showMore.bind(this);
        this.showLess = this.showLess.bind(this);
    }
    
    draw(props: FeaturedCategoryComponentProps, state: UIComponentState, cssStyle: FeaturedCategoryCSSStyle): JSX.Element
    {
        super.draw(props, state, cssStyle);
        return (
            <>
          <div id="featured-catgeory-grid-tabs" style={cssStyle.getWrapperCSSStyle()}>
              <GridTabComponent id="featured-catgeory-grid-tabs" onTabSelected={this.onTabSelected} ref={(item: any)=>{this.gridTabRef = item;}} initialTab={this.genericTabViewModel.getListOfTitles()[0]} genericTabViewModel={this.genericTabViewModel} context={props.context}/>
          </div>
          </>
        );
    }

    onTabSelected()
    {
        // let tab = this.genericTabViewModel.getTab(title);
        // console.log("----tab: " + tab + ", title:" + title);
      
        // tab !== undefined && (tab as FeaturedCategoryTabViewModelImpl).refreshData();
    }

    updateProfileTab(context: BaseContext, title: string, tonedto: ToneDto[])
    {
        this.genericTabViewModel.addTab(new FeaturedCategoryTabViewModelImpl(context, title, 
            new FeaturedToneListViewModelImpl(context.getConfigurationSettings().getProperty("FETCH_LIMIT"),
            this.audioPlayerWithProgress, new ProfileTunesFeaturedToneRowOptionsImpl(), context, 
            "30px", title), this.showMore, this.showLess));
        let tab = this.genericTabViewModel.getTab(title);
          
        tab !== undefined && (tab as FeaturedCategoryTabViewModelImpl).updateTabData(tonedto, true, 0, false);
    }

    updateTabData(context: BaseContext, title: string, tonedto: ToneDto[])
    {
        this.featuredCategoryTonesListMap.set(title, tonedto);
        this.genericTabViewModel.addTab(new FeaturedCategoryTabViewModelImpl(context, title, 
            new FeaturedToneListViewModelImpl(context.getConfigurationSettings().getProperty("FETCH_LIMIT"),
            this.audioPlayerWithProgress, new FeaturedToneRowOptionsImpl(), context, "30px", title),
            this.showMore, this.showLess));

        let tab = this.genericTabViewModel.getTab(title);
      
        tab !== undefined && (tab as FeaturedCategoryTabViewModelImpl).updateTabData(tonedto.slice(0, 8),
        true, 0, false);
    }
   
    showMore()
    {
        
        let tab = this.genericTabViewModel.getTab(this.genericTabViewModel.getSelectedTabTitle());
        let toneDtoList = this.featuredCategoryTonesListMap.get(this.genericTabViewModel.getSelectedTabTitle());

        if(tab !== undefined && toneDtoList !== undefined)
        {
            if(toneDtoList.length > 10)
            {
                let tabIdentifier = this.featuredCategoryMap.get(this.genericTabViewModel.getSelectedTabTitle());

                if(tabIdentifier !== undefined)
                {
                this.getUIProps().context.getRedirectionHandler().routeNextFeature(
                    RoutingFeatures.FEATURED_CATEGROIES + "?identifier=" + tabIdentifier
                    + "&title=" + this.genericTabViewModel.getSelectedTabTitle(), false);
                }
            }
            else
            {
                this.featuredCategoryTonesListMap.set(this.genericTabViewModel.getSelectedTabTitle(), toneDtoList);
            
                (tab as FeaturedCategoryTabViewModelImpl).updateTabData(toneDtoList, false, 7, true);
                this.gridTabRef.onTabSelected(this.genericTabViewModel.getSelectedTabTitle());
            }
            // let showmore = document.getElementById("featured-catgeory-grid-tabs");
            // if(showmore !== null)
            // {
            //     let offsetTop = showmore.getBoundingClientRect().top + window.scrollY;
            //     console.log("------offsetTop: " + offsetTop);
            //     window.scroll(0, (offsetTop - 200));
            // }
        }
    }

    showLess()
    {
        let tab = this.genericTabViewModel.getTab(this.genericTabViewModel.getSelectedTabTitle());
        let toneDto = this.featuredCategoryTonesListMap.get(this.genericTabViewModel.getSelectedTabTitle());
      
        if(tab !== undefined && toneDto !== undefined)
        {
            let filteredToneDtos:ToneDto[] = [];

            toneDto.forEach((toneDto1: ToneDto, index: number) =>
            {
                (index <= 7) && filteredToneDtos.push(toneDto1);
            });
          
            (tab as FeaturedCategoryTabViewModelImpl).updateTabData(filteredToneDtos, true, 0, true);
            this.gridTabRef.onTabSelected(this.genericTabViewModel.getSelectedTabTitle());
        }
    }
    updateTab()
    {
        this.gridTabRef.onTabSelected(this.genericTabViewModel.getListOfTitles()[0]);
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/featuredcategory/featuredview.tsx